import React, { useEffect, useState, useRef } from "react"
import "./PortalUser.scss"
import AuthenticationApi from "Api/AuthenticationApi"

import CheckboxTree from "react-checkbox-tree"
import "react-checkbox-tree/lib/react-checkbox-tree.css"

import * as Yup from "yup"
import { menuItems } from "components/VerticalLayout/Menu"

import { useNavigate } from "react-router-dom"
import {
  Button,
  Col,
  Modal,
  Row,
  Table,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Input,
} from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { set } from "lodash"
import DataTableLoader from "SkeletonLoader/DataTableLoader"
import { Toast } from "primereact/toast"
import { StandardPagination, StatusBadge, ActionIcon } from "components/Common"

const PortalUserList = () => {
  document.title = "PortalUsers"
  const navigate = useNavigate("")
  const accessToken = localStorage.getItem("accessToken")
  const userData = JSON.parse(localStorage.getItem("userData"))
  const permissions = userData?.permission || []

  const [page, setPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [limit, setLimit] = useState(10)

  const [modal, setModal] = useState(false)
  const [editModal, setEditModal] = useState(false)

  const toggle = () => setModal(!modal)
  const editToggle = () => setEditModal(!editModal)
  const [editData, setEditData] = useState({})
  const toast = useRef(null)

  const breadcrumbItems = [
    { label: "Pixwik", link: "/ " },
    { label: "Portal Users", link: "/PortalUsers" },
  ]
  const handleBreadcrumbClick = link => {
    if (link !== "#") {
      navigate(link)
    }
  }
  const [usersData, setuserData] = useState([])
  const [loading, setLoading] = useState(true)
  const [addUserLoader, setAddUserLoader] = useState(false)

  const [selectedPermissions, setSelectedPermissions] = useState([])
  const [selectedTypes, setSelectedTypes] = useState({})
  const [expandedPermissions, setExpandedPermissions] = useState([])
  const [deleteModal, setDeleteModal] = useState(false)
  const [userToDelete, setUserToDelete] = useState(null)
  const [otpInput, setOtpInput] = useState("")
  const [isOtpSent, setIsOtpSent] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const [deletedReason, setDeletedReason] = useState("")
  const deleteToggle = () => setDeleteModal(!deleteModal)
  const getAllAnalystDetails = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        limit: limit,
        page: page,
      },
    }

    AuthenticationApi.getAnalyst(config)
      .then(response => {
        if (response.data.status) {
          setLoading(false)
          setuserData(response.data.users)
          setTotalRecords(response.data.totalRecords)
        }
      })
      .catch(error => {
        console.error("Error fetching university:", error)
      })
  }

  useEffect(() => {
    getAllAnalystDetails()
  }, [accessToken, page, limit])

  const totalPages = Math.ceil(totalRecords / limit)

  const capitalizeString = str => {
    return str
      .split(" ")
      .map(word => word.slice(0, 1).toLocaleUpperCase() + word.slice(1))
      .join(" ")
  }

  const roleOptions = [{ name: "sub admin", value: "sub admin" }]

  // Generate permissions data dynamically from menu items
  const generatePermissionsFromMenu = (menuItems) => {
    const transformMenuItem = (item) => {
      const permission = {
        value: item.id,
        label: item.label,
        types: item.types || ["GET", "POST", "PUT", "DELETE"],
        children: []
      }

      // Handle sub-items recursively
      if (item.subItems && item.subItems.length > 0) {
        permission.children = item.subItems.map(transformMenuItem)
      }

      return permission
    }

    return menuItems.map(transformMenuItem)
  }

  const permissionsData = generatePermissionsFromMenu(menuItems)






  const initialUserData = {
    userName: "",
    email: "",
    role: "",
    permission: [],
  }

  const [addUserData, setAddUserData] = useState(initialUserData)
  const handleAddUserDataChange = (name, value) => {
    setAddUserData(prevData => ({
      ...prevData,
      [name]: value,
    }))
  }

  const validateAddUser = Yup.object().shape({
    userName: Yup.string().required("User name is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    role: Yup.string().oneOf(["sub admin", "admin"], "Inavlid User Role"),
  })

  const [errors, setErrors] = useState({})
  const getAllDescendants = node => {
    let descendants = []
    if (!node?.children) return descendants

    for (const child of node.children) {
      descendants.push(child.value)
      descendants = [...descendants, ...getAllDescendants(child)]
    }
    return descendants
  }

  const getAllAncestors = (nodes, value, path = []) => {
    if (!nodes) return null

    for (const node of nodes) {
      if (node.value === value) {
        return path
      }
      if (node.children) {
        const newPath = [...path, node.value]
        const found = getAllAncestors(node.children, value, newPath)
        if (found) return found
      }
    }
    return null
  }

  const findNodeByValue = (nodes, value) => {
    if (!nodes) return null

    for (const node of nodes) {
      if (node.value === value) return node
      if (node.children) {
        const found = findNodeByValue(node.children, value)
        if (found) return found
      }
    }
    return null
  }

  const handlePermissionChange = checked => {
    setSelectedPermissions(checked);

    // Initialize types for newly selected permissions
    const newTypes = { ...selectedTypes };

    // Remove types for unselected permissions
    Object.keys(newTypes).forEach(key => {
      if (!checked.includes(key)) {
        delete newTypes[key];
      }
    });

    setSelectedTypes(newTypes);
  }

  const handleTypeChange = (permission, type) => {
    try {
      setSelectedTypes(prevTypes => {
        const newTypes = JSON.parse(JSON.stringify(prevTypes));

        if (!newTypes[permission]) {
          newTypes[permission] = [];
        }

        const index = newTypes[permission].indexOf(type);

        if (index === -1) {
          newTypes[permission].push(type);
        } else {
          newTypes[permission].splice(index, 1);
        }

        return newTypes;
      });
    } catch (error) {
      console.error('Error in handleTypeChange:', error);
    }
  }

  const renderPermissionTypes = permission => {
    const node = permissionsData.find(item => item.value === permission) ||
      permissionsData.flatMap(item => item.children || []).find(child => child.value === permission) ||
      permissionsData.flatMap(item => (item.children || []).flatMap(child => child.children || [])).find(grandChild => grandChild.value === permission);

    if (!node) return null;

    const handleCheckboxClick = (type) => {
      handleTypeChange(permission, type);
    };

    return (
      <div key={permission} className="permission-type-container mb-3 p-3 border rounded">
        <div className="permission-header mb-2">
          <strong>{node.label}</strong>
        </div>
        <div className="permission-types d-flex flex-wrap gap-3">
          {["GET", "POST", "PUT", "DELETE"].map(type => {
            const isChecked = selectedTypes[permission]?.includes(type) || false;

            return (
              <div
                key={`${permission}-${type}`}
                className="form-check"
                onClick={(e) => {
                  e.preventDefault();
                  handleCheckboxClick(type);
                }}
                style={{ cursor: 'pointer' }}
              >
                <input
                  type="checkbox"
                  id={`${permission}-${type}`}
                  className="form-check-input"
                  checked={isChecked}
                  onChange={() => { }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCheckboxClick(type);
                  }}
                  style={{ cursor: 'pointer' }}
                />
                <label
                  className="form-check-label ms-2"
                  htmlFor={`${permission}-${type}`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleCheckboxClick(type);
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  {type}
                </label>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const hasPermission = (userPermissions, resource, method) => {
    if (
      !userPermissions?.permission ||
      !Array.isArray(userPermissions.permission)
    ) {
      return false
    }

    // Check direct permission
    const directPermission = userPermissions.permission.some(
      perm =>
        perm.permissionName === resource &&
        perm.permissionType.includes(method),
    )
    if (directPermission) return true

    // Check ancestor permissions
    const ancestors = getAllAncestors(permissionsData, resource)
    if (!ancestors) return false

    return ancestors.some(ancestor =>
      userPermissions.permission.some(
        perm =>
          perm.permissionName === ancestor &&
          perm.permissionType.includes(method),
      ),
    )
  }

  const createUser = () => {
    setAddUserLoader(true)
    validateAddUser
      .validate(addUserData, { abortEarly: false })
      .then(() => {
        const config = {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }

        // Format permissions with their types
        const permission = selectedPermissions.map(perm => ({
          permissionName: perm,
          permissionType: selectedTypes[perm] || []
        }));

        const userData = { ...addUserData, permission }

        AuthenticationApi.createUser(userData, config)
          .then(response => {
            setAddUserData(initialUserData)
            if (response.data.status) {
              getAllAnalystDetails()
              toggle()
              toast.current.show({
                severity: "success",
                summary: "Success",
                detail: "User Added successfully",
                life: 3000,
              })
              setAddUserLoader(false)
            }
          })
          .catch(error => {
            console.error("Error fetching user:", error)
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: error.response?.data?.message || "Failed to create user. Please try again!",
              life: 3000,
            })
            setAddUserLoader(false)
          })
      })
      .catch(err => {
        const validationErrors = {}
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message
        })
        setErrors(validationErrors)
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Please fill all required fields correctly!",
          life: 3000,
        })
        setAddUserLoader(false)
      })
  }

  const updateRole = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
    const payload = {
      userId: editData.userId,
      role: editData.role,
    }
    AuthenticationApi.updateRole(payload, config)
      .then(response => {
        if (response.data.status) {
          getAllAnalystDetails()
          editToggle()
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "User Role Updated successfully",
            life: 3000,
          })
        }
      })
      .catch(error => {
        console.error("Error fetching user:", error)
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail:
            error.response?.data?.message ||
            "Failed to update user role. Please try again!",
          life: 3000,
        })
      })
  }

  const handleAddUserClick = () => {
    toggle()
  }

  const handleDeleteUser = userId => {
    setUserToDelete(userId)
    setDeleteModal(true)
    setOtpInput("")
    setDeletedReason("")
    setIsOtpSent(false)
  }

  const generateOtp = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    setIsDeleting(true)

    // Update this API call to include userId in the URL
    AuthenticationApi.generateDeleteUserOtp(userToDelete, config)
      .then(response => {
        if (response.data.status) {
          setIsOtpSent(true)
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "OTP has been sent to admin email",
            life: 3000,
          })
        }
      })
      .catch(error => {
        console.error("Error generating OTP:", error)
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: error.response?.data?.message || "Failed to send OTP",
          life: 3000,
        })
      })
      .finally(() => {
        setIsDeleting(false)
      })
  }

  const handleOtpChange = e => {
    const value = e.target.value
    if (value.length <= 5) {
      setOtpInput(value)
    }
  }

  const confirmDelete = () => {
    if (!otpInput) {
      toast.current.show({
        severity: "warn",
        summary: "Warning",
        detail: "Please enter OTP",
        life: 3000,
      })
      return
    }

    if (!deletedReason.trim()) {
      toast.current.show({
        severity: "warn",
        summary: "Warning",
        detail: "Please provide a reason for deletion",
        life: 3000,
      })
      return
    }

    setIsDeleting(true)
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    const data = {
      otp: otpInput,
      deletedReason: deletedReason,
    }

    // Update this API call to match the backend expectations
    AuthenticationApi.deletePortalUser(userToDelete, data, config)
      .then(response => {
        if (response.data.status) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: response.data.message,
            life: 3000,
          })
          getAllAnalystDetails()
          handleCloseModal()
        }
      })
      .catch(error => {
        console.error("Error deleting user:", error)
        const errorMessage =
          error.response?.data?.message || "Failed to delete user"
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: errorMessage,
          life: 3000,
        })

        if (
          errorMessage.includes("Invalid OTP") ||
          errorMessage.includes("expired")
        ) {
          setOtpInput("")
        }
      })
      .finally(() => {
        setIsDeleting(false)
      })
  }

  const handleCloseModal = () => {
    setDeleteModal(false)
    setUserToDelete(null)
    setOtpInput("")
    setDeletedReason("")
    setIsOtpSent(false)
    setIsDeleting(false)
  }

  return (
    <>
      <Toast ref={toast} position="top-right" life="3000" />
      <Row>
        <Col xs="12">
          {(userData.role === "admin" ||
            hasPermission(permissions, "portalUsers", "PUT")) && (
              <div className="user-list-header d-flex  align-items-center justify-content-between">
                <CustomBreadCrumb
                  data={breadcrumbItems}
                  pageTitle="Portal Users"
                  handleClick={handleBreadcrumbClick}
                />

                <Button
                  type="button"
                  color="secondary"
                  className="waves-effect"
                  onClick={handleAddUserClick}
                >
                  Add Sub Admin
                </Button>
              </div>
            )}
          {(userData.role === "admin" ||
            hasPermission(permissions, "portalUsers", "GET")) && (
              <div className="data-table-container">
                <div className="table-responsive">
                  {loading ? (
                    <DataTableLoader cols={5} />
                  ) : (
                    <Table className="table mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>User Name</th>
                          <th>Email</th>
                          <th>Role</th>
                          <th>Status</th>
                          {(userData.role === "admin" ||
                            hasPermission(permissions, "portalUsers", "PUT")) && (
                              <th>Edit</th>
                            )}
                          {(userData.role === "admin" ||
                            hasPermission(permissions, "portalUsers", "GET")) && (
                              <th>View</th>
                            )}
                          {(userData.role === "admin" ||
                            hasPermission(
                              permissions,
                              "portalUsers",
                              "DELETE",
                            )) && <th className="text-center">Delete</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {usersData?.map((user, index) => (
                          <tr key={user._id} className="user-table-row">
                            <th scope="row">{(page - 1) * limit + index + 1}</th>
                            <td>{user.userName}</td>
                            <td>{user.email}</td>
                            <td>{capitalizeString(user.role)}</td>
                            <td>
                              <StatusBadge
                                status={user.isActive ? "Active" : "Inactive"}
                                type={user.isActive ? "active" : "inactive"}
                              />
                            </td>
                            {(userData.role === "admin" ||
                              hasPermission(permissions, "portalUsers", "PUT")) && (
                                <td>
                                  <ActionIcon
                                    type="edit"
                                    onClick={() => {
                                      setEditData(user)
                                      editToggle()
                                    }}
                                    tooltip="Edit User"
                                  />
                                </td>
                              )}
                            {(userData.role === "admin" ||
                              hasPermission(permissions, "portalUsers", "GET")) && (
                                <td>
                                  <ActionIcon
                                    type="view"
                                    onClick={() => {
                                      navigate(`/view-portal-user/${user._id}`)
                                    }}
                                    tooltip="View User"
                                  />
                                </td>
                              )}
                            {(userData.role === "admin" ||
                              hasPermission(
                                permissions,
                                "portalUsers",
                                "DELETE",
                              )) && (
                                <td className="text-center">
                                  <ActionIcon
                                    type="delete"
                                    onClick={() => handleDeleteUser(user._id)}
                                    tooltip="Delete User"
                                  />
                                </td>
                              )}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                </div>
              </div>
            )}
          <StandardPagination
            currentPage={page}
            totalPages={totalPages}
            onPageChange={setPage}
          />
        </Col>
      </Row>

      <div className="add-user-dialog">
        <Modal isOpen={modal} toggle={toggle} centered size="lg">
          <ModalHeader toggle={toggle}>Invite User</ModalHeader>
          <ModalBody style={{ maxHeight: '80vh', overflowY: 'auto', padding: '20px' }}>
            <div className="invite-user-form">
              <div className="form-group">
                <label htmlFor="userName"> Name</label>
                <InputText
                  value={addUserData.userName}
                  onChange={e => {
                    handleAddUserDataChange("userName", e.target.value)
                  }}
                  placeholder="Enter Name"
                />
                {errors.userName && (
                  <small className="error">{errors.userName}</small>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <InputText
                  value={addUserData.email}
                  onChange={e => {
                    handleAddUserDataChange("email", e.target.value)
                  }}
                  placeholder="Enter Email"
                />
                {errors.email && (
                  <small className="error">{errors.email}</small>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="userName">Role</label>
                <Dropdown
                  value={addUserData.role}
                  onChange={e => {
                    handleAddUserDataChange("role", e.target.value)
                  }}
                  optionLabel="name"
                  options={roleOptions}
                  placeholder="Choose Role"
                />
                {errors.role && <small className="error">{errors.role}</small>}
              </div>
              <div className="form-group">
                <label htmlFor="permissions" className="mb-2">
                  Permissions
                </label>
                <div className="mb-3">
                  <CheckboxTree
                    nodes={permissionsData}
                    checked={selectedPermissions}
                    expanded={expandedPermissions}
                    onCheck={handlePermissionChange}
                    onExpand={expanded => setExpandedPermissions(expanded)}
                    iconsClass="fa5"
                    showExpandAll
                    noCascade={true}
                  />
                </div>

                {selectedPermissions.length > 0 && (
                  <div className="selected-permissions mt-4">
                    <h6 className="mb-3">Select Permission Types</h6>
                    {selectedPermissions.map(permission =>
                      renderPermissionTypes(permission),
                    )}
                  </div>
                )}
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={toggle}>
              Cancel
            </Button>
            <Button
              color="secondary"
              onClick={() => {
                createUser()
              }}
            >
              {addUserLoader ? <Spinner size="sm" /> : " Add "}
            </Button>{" "}
          </ModalFooter>
        </Modal>
        <Modal isOpen={editModal} toggle={editToggle} centered size="lg">
          <ModalHeader toggle={editToggle}>User</ModalHeader>
          <ModalBody style={{ maxHeight: '80vh', overflowY: 'auto', padding: '20px' }}>
            <div className="invite-user-form">
              <div className="form-group">
                <label htmlFor="userName"> Name</label>
                <InputText value={editData.userName} disabled />
                {errors.userName && (
                  <small className="error">{errors.userName}</small>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <InputText value={editData.email} disabled />
                {errors.email && (
                  <small className="error">{errors.email}</small>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="userName">Role</label>
                <Dropdown
                  value={editData.role}
                  onChange={e => {
                    setEditData(prevData => {
                      return { ...prevData, role: e.target.value }
                    })
                  }}
                  optionLabel="name"
                  options={roleOptions}
                  placeholder="Choose Role"
                />
                {errors.role && <small className="error">{errors.role}</small>}
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={toggle}>
              Cancel
            </Button>
            <Button
              color="secondary"
              onClick={() => {
                updateRole()
              }}
            >
              {addUserLoader ? <Spinner size="sm" /> : " Save "}
            </Button>{" "}
          </ModalFooter>
        </Modal>
        <Modal isOpen={deleteModal} toggle={handleCloseModal} centered size="lg">
          <ModalHeader toggle={handleCloseModal}>Delete User</ModalHeader>
          <ModalBody>
            <div className="text-center">
              <i
                className="ri-delete-bin-2-line"
                style={{ fontSize: "3rem", color: "#f46a6a" }}
              />
              <h4 className="mt-3">Are you sure?</h4>
              <p className="text-muted">
                Do you really want to delete this user? This action cannot be
                undone.
              </p>
              {!isOtpSent ? (
                <Button
                  color="primary"
                  onClick={generateOtp}
                  className="mt-2"
                  disabled={isDeleting}
                >
                  {isDeleting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-1" />
                      Sending...
                    </>
                  ) : (
                    "Generate OTP"
                  )}
                </Button>
              ) : (
                <div className="mt-3">
                  <p className="text-muted mb-2">
                    Please enter the OTP sent to admin email
                  </p>
                  <Input
                    type="text"
                    placeholder="Enter OTP"
                    value={otpInput}
                    onChange={handleOtpChange}
                    className="text-center otp-input mb-3"
                    maxLength="5"
                    autoComplete="off"
                  />

                  <div className="mt-3">
                    <label className="form-label text-start d-block">
                      Reason for Deletion
                    </label>
                    <Input
                      type="textarea"
                      placeholder="Please provide a reason for deletion"
                      value={deletedReason}
                      onChange={e => setDeletedReason(e.target.value)}
                      className="reason-input"
                      rows="3"
                      required
                    />
                  </div>
                </div>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="light"
              onClick={handleCloseModal}
              disabled={isDeleting}
            >
              Cancel
            </Button>
            {isOtpSent && (
              <Button
                color="danger"
                onClick={confirmDelete}
                disabled={isDeleting || !otpInput || !deletedReason.trim()}
              >
                {isDeleting ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-1" />
                    Deleting...
                  </>
                ) : (
                  "Delete"
                )}
              </Button>
            )}
          </ModalFooter>
        </Modal>
      </div>
    </>
  )
}

export default PortalUserList
